import { render, staticRenderFns } from "./SaveNoticeboardModal.vue?vue&type=template&id=6b918af5&scoped=true&"
import script from "./SaveNoticeboardModal.vue?vue&type=script&lang=ts&"
export * from "./SaveNoticeboardModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b918af5",
  null
  
)

export default component.exports